import { Col, Row } from "antd";
import React from "react";
import "./style.scss";

const SectionInfoDescriptionItem = (props: any) => {
  const { item } = props;

  return item ? (
    <a
      style={{
        backgroundColor: item.background_color,
      }}
      className="section-info-description-item-wrapper">
      <Row
        justify="center"
        align="middle"
        className="section-info-description-item-wrap">
        <Col span={24}>
          <Row justify="center" align="middle">
            <span className="sub-title info-description-item-title">
              {item.title}
            </span>
          </Row>
          <Row justify="center" align="middle">
            <span className="main-content info-description-item-sub-title">
              {item.sub_title}
            </span>
          </Row>
          <Row
            justify="center"
            align="middle"
            className="info-description-item-image">
            <img src={item.images[0].galaries[0].path} alt="" />
          </Row>
          <Row justify="center" align="middle">
            <span className="main-content info-description-item-content">
              {item.content}
            </span>
          </Row>
        </Col>
      </Row>
    </a>
  ) : null;
};

export default SectionInfoDescriptionItem;
